
const libPictView = require('pict-view');
const libNavigationTopics = require('../navigation-topics.js');

const html = String.raw;

/**
 * Host view — a per-topic dashboard page.
 *
 * One generic view drives every top-level topic (Users, Projects, Observations, Forms,
 * Data Lake). The router sets AppData.CurrentTopic to a TOPIC_CONFIGS entry before
 * rendering; this view paints a KPI jumbotron for that topic and a pre-filtered nav list
 * (pict-section-navigation List scoped to the topic's category hashes).
 */
class TopicPage extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	get _topic()
	{
		return this.pict.AppData.CurrentTopic || libNavigationTopics.TOPIC_CONFIGS.Settings;
	}

	onBeforeRender(pRenderable)
	{
		const tmpTopic = this._topic;
		this.pict.AppData.NavJumbo = { Title: tmpTopic.Title, Icon: tmpTopic.Icon, Blurb: tmpTopic.Blurb };
		this.pict.AppData.NavKpis = libNavigationTopics.buildKpiRecords(
			this.pict.AppData.DashboardStats, tmpTopic.KpiKeys, this.pict.PictApplication.isHeadlightSession());
		return super.onBeforeRender(pRenderable);
	}

	onAfterRender(pRenderable)
	{
		const tmpTopic = this._topic;

		// Optional "coming soon" banner (Data Lake).
		this.pict.ContentAssignment.assignContent('#TopicPage-Note', tmpTopic.ComingSoon
			? `<div class="topic-comingsoon"><span class="icon"><i class="fas fa-hard-hat"></i></span> <span>This area is just getting started — the tools below are available now, with more on the way.</span></div>`
			: '');

		// Pre-filtered nav list for this topic (the global customer gate still applies).
		const tmpProvider = this.pict.providers['Pict-Navigation'];
		if (tmpProvider)
		{
			tmpProvider.render('List', '#TopicPage-Nav', { Scope: tmpTopic.Scope });
		}

		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable);
	}
}

module.exports = TopicPage;

module.exports.default_configuration =
{
	ViewIdentifier: 'TopicPage',
	DefaultRenderable: 'TopicPageWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,

	CSS: /*css*/`
.topic-comingsoon { display: flex; align-items: center; gap: 0.6rem; max-width: 780px; margin: 0 auto 1.25rem;
	background: var(--bulma-scheme-main-bis, #f4f6fa); border: 1px dashed var(--bulma-border, #d7dce3);
	border-radius: 10px; padding: 0.7rem 1rem; color: var(--bulma-text-weak, #6b7686); font-size: 0.9rem; }
.topic-comingsoon .icon { color: var(--bulma-link, #156dd1); }
`,

	Templates:
	[
		libNavigationTopics.KPI_CARD_TEMPLATE,
		{
			Hash: 'TopicPage-Template',
			Template: html`
				<section class="section">
					<div class="container">
						<div class="nav-jumbo">
							<div class="nav-jumbo-head">
								<span class="nav-jumbo-ic"><i class="{~D:AppData.NavJumbo.Icon~}"></i></span>
								<div>
									<h1 class="nav-jumbo-title">{~D:AppData.NavJumbo.Title~}</h1>
									<p class="nav-jumbo-sub">{~D:AppData.NavJumbo.Blurb~}</p>
								</div>
							</div>
							<div class="nav-kpi-strip">{~TS:Nav-Kpi-Card:AppData.NavKpis~}</div>
						</div>
						<div id="TopicPage-Note"></div>
						<div id="TopicPage-Nav" class="pict-nav"></div>
					</div>
				</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'TopicPageWrap',
			TemplateHash: 'TopicPage-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
